import { Result } from 'antd';
import React, { FC } from 'react';
import { useDispatch } from 'react-redux';
import { PageLoading } from 'components/atoms/loading';
import { saveFields } from 'data/fields';
import { useAccount } from 'hooks/use-account';
import { useTaskFieldsQuery } from 'queries';

export const TaskFieldsProvider: FC = (props) => {
  const { children } = props;
  const dispatch = useDispatch();
  const { isLoading, isError } = useTaskFieldsQuery({
    onSuccess: (result) => {
      dispatch(saveFields(result));
    },
  });

  const { accountId } = useAccount();

  if (isError) {
    /* TODO:: Can be improved. */
    return (
      <Result
        status="500"
        title="500"
        subTitle="Sorry, something went wrong. Please refresh the page."
      />
    );
  }

  if (accountId && !isLoading) {
    return <>{children}</>;
  }

  return <PageLoading size="large" />;
};
